import styled from '@emotion/styled';
import React from 'react';
import { messages } from '../messages';

export function Subtitle(
  edition: string | null | undefined,
  isWhiteBackground: boolean
) {
  switch (edition) {
    case 'standard':
      return (
        <SubtitleText primary={isWhiteBackground}>
          {messages.cloudStandard.defaultMessage}
        </SubtitleText>
      );
    case 'premium':
      return (
        <SubtitleText primary={isWhiteBackground}>
          {messages.cloudPremium.defaultMessage}
        </SubtitleText>
      );
    default:
      return (
        <SubtitleText primary={isWhiteBackground}>
          {messages.cloudFree.defaultMessage}
        </SubtitleText>
      );
  }
}

const SubtitleText = styled.h4<{ primary: boolean }>`
  margin: 0px;
  font-size: 20px;
  font-weight: 400;
  color: ${(props) => (props.primary ? 'rgba(13, 20, 36, 0.97)' : 'white')};
`;
